import { cn } from "@/lib/utils";
import { useLanguage } from "@/services/languageService";

interface PokemonTypeTagProps {
  type: string;
  className?: string;
}

const PokemonTypeTag = ({ type, className }: PokemonTypeTagProps) => {
  const { t } = useLanguage();
  const label = t(type);
  const displayLabel =
    label && label !== type
      ? label
      : type.charAt(0).toUpperCase() + type.slice(1);

  const getTypeColor = (type: string) => {
    // Color mapping based on Pokémon types
    const typeColors: Record<string, string> = {
      normal: "bg-pokemon-normal",
      fire: "bg-pokemon-fire",
      water: "bg-pokemon-water",
      electric: "bg-pokemon-electric",
      grass: "bg-pokemon-grass",
      ice: "bg-pokemon-ice",
      fighting: "bg-pokemon-fighting",
      poison: "bg-pokemon-poison",
      ground: "bg-pokemon-ground",
      flying: "bg-pokemon-flying",
      psychic: "bg-pokemon-psychic",
      bug: "bg-pokemon-bug",
      rock: "bg-pokemon-rock",
      ghost: "bg-pokemon-ghost",
      dragon: "bg-pokemon-dragon",
      dark: "bg-pokemon-dark",
      steel: "bg-pokemon-steel",
      fairy: "bg-pokemon-fairy",
    };

    return typeColors[type] || "bg-gray-500";
  };

  return (
    <span className={cn("type-badge", getTypeColor(type), className)}>
      {displayLabel}
    </span>
  );
};

export default PokemonTypeTag;
